module.exports = __webpack_public_path__ + "static/img/tm-6.98c9880.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/tm-6.jpg
// module id = qMkK
// module chunks = 0